<p-card>
  <div class="flex items-start gap-1.5 mb-5">
    <h2 class="text-heading-lg font-bold">
      {{ 'projectInsight.investmentRounds.title' | translate }}
    </h2>
    <i
      class="pi pi-question-circle text-sm text-primary"
      [pTooltip]="'projectInsight.investmentRounds.tooltip' | translate"
    ></i>
  </div>

  <div class="flex flex-col lg:flex-row items-center justify-between w-full gap-4">
    @for (round of rounds(); track round.type; let i = $index; let isLast = $last) {
    <!-- Round Item -->
    <div
      class="investment-round-item flex flex-col gap-2.5 items-start p-3 rounded-lg w-full lg:flex-1"
      [ngClass]="{
        'investment-round-live': round.isLive,
        'investment-round-inactive': !round.isLive
      }"
    >
      <div class="flex items-center gap-2">
        <span class="text-body-md !font-bold !text-text-primary">
          @if (round.type === 'private') {
          {{ 'projectInsight.investmentRounds.privateSale' | translate }} } @else if (round.type ===
          'public') { {{ 'projectInsight.investmentRounds.publicSale' | translate }} } @else if
          (round.type === 'tge') { {{ 'projectInsight.investmentRounds.tgeDate' | translate }} }
        </span>
        @if (round.isLive) {
        <div class="live-badge rounded px-1.5 py-0">
          <span class="text-label-md-semibold text-warning-800">{{
            'projectInsight.investmentRounds.live' | translate
          }}</span>
        </div>
        }
      </div>

      <div class="flex flex-col gap-2 items-start">
        <span class="text-label-md-semibold text-primary">
          {{ round.price }}
        </span>
        <span class="text-label-md-semibold text-secondary">
          {{ round.startDate }}@if (round.endDate) { – {{ round.endDate }} }
        </span>
      </div>
    </div>

    @if (!isLast) {
    <!-- Arrow Divider - Down on mobile, Right on desktop -->
    <div class="lg:hidden flex items-center justify-center">
      <i class="pi pi-arrow-down text-primary text-xl"></i>
    </div>
    <div class="hidden lg:flex items-center justify-center">
      <i class="pi pi-arrow-right text-primary text-xl"></i>
    </div>
    } }
  </div>
</p-card>
